const links = [
  {
    key: "twitter",
    url: "https://www.twitter.com/abulnes16",
    icon: (
      <span
        className="iconify icon-xl"
        data-icon="bytesize:twitter"
        data-inline="false"
      ></span>
    ),
  },
  {
    key: "linkedin",
    url: "https://www.linkedin.com/in/angel-bulnes16/",
    icon: (
      <span
        className="iconify icon-xl"
        data-icon="bx:bxl-linkedin"
        data-inline="false"
      ></span>
    ),
  },
  {
    key: "github",
    url: "https://www.github.com/abulnes16",
    icon: (
      <span
        className="iconify icon-xl"
        data-icon="ant-design:github-outlined"
        data-inline="false"
      ></span>
    ),
  },
  {
    url: "https://www.medium.com/@abulnes16",
    icon: (
      <span
        className="iconify icon-xl"
        data-icon="ant-design:medium-outlined"
        data-inline="false"
      ></span>
    ),
  },
];

export default links;
